/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2025-07-15 14:10:47
 * @LastEditors: linxi
 * @LastEditTime: 2025-08-21 17:21:12
 */
import { createAsyncThunk } from '@reduxjs/toolkit'
import _ from 'lodash'
import { sendAsync } from '../../../app/applicationSlice'
import { RootThunkApi } from '../../../app/store'
import {
  TIManagementListParams,
  getTIManagementList,
  getTIManagementDetail,
  getTIManagementSubmit,
  getRemove,
  SubmitParams,
  TrainingRecordListParams,
  getTrainingRecordList,
  getTrainingRecordDetail,
  TrainingRecordSubmitParams,
  getTrainingRecordSubmit,
  getTrainingRecordRemove,
  DetailParams,
} from '../../../services/TIManagement'

// 列表
export const getTIManagementListAsync = createAsyncThunk<
  void,
  TIManagementListParams,
  RootThunkApi<void>
>('TIManagement/getTIManagementListAsync', async (params, api) => {
  return sendAsync(getTIManagementList(params), api)
})

// 详情
export const getTIManagementDetailAsync = createAsyncThunk<
  void,
  DetailParams,
  RootThunkApi<void>
>('TIManagement/getTIManagementDetailAsync', async (params, api) => {
  return sendAsync(getTIManagementDetail(params), api)
})

// 保存编辑
export const getTIManagementSubmitAsync = createAsyncThunk<
  void,
  SubmitParams,
  RootThunkApi<void>
>('TIManagement/getTIManagementSubmitAsync', async (params, api) => {
  return sendAsync(getTIManagementSubmit(params), api)
})

// 删除
export const getRemoveAsync = createAsyncThunk<void, any, RootThunkApi<void>>(
  'TIManagement/getRemoveAsync',
  async (params, api) => {
    return sendAsync(getRemove(params), api)
  }
)

// 列表
export const getTrainingRecordListAsync = createAsyncThunk<
  any,
  TrainingRecordListParams,
  RootThunkApi<void>
>('TrainingRecord/getTrainingRecordList', async (params, api) => {
  return sendAsync(getTrainingRecordList(params), api)
})

// 详情
export const getTrainingRecordDetailAsync = createAsyncThunk<
  void,
  DetailParams,
  RootThunkApi<void>
>('TrainingRecord/getTrainingRecordDetailAsync', async (params, api) => {
  return sendAsync(getTrainingRecordDetail(params), api)
})

// 保存编辑
export const getTrainingRecordSubmitAsync = createAsyncThunk<
  void,
  TrainingRecordSubmitParams,
  RootThunkApi<void>
>('TrainingRecord/getTrainingRecordSubmitAsync', async (params, api) => {
  return sendAsync(getTrainingRecordSubmit(params), api)
})

// 删除
export const getTrainingRecordRemoveAsync = createAsyncThunk<
  void,
  any,
  RootThunkApi<void>
>('TrainingRecord/getTrainingRecordRemoveAsync', async (params, api) => {
  return sendAsync(getTrainingRecordRemove(params), api)
})
